import React from "react";
import { connect } from "react-redux";

import {
  instaFollow,
  birthDay,
  fbLike,
  fbShare,
  freeProduct,
  signUp,
  twitterFollow,
  twitterShare,
  orderOnline,
} from "../../helpers/icons";
import WaysToEarnItem from "./WaysToEarnItem";
import { fetchCustomer } from "../../actions/customerActions";
import {
  giveSocialGiftcard,
  giveSocialPoints,
  checkTierBenefitsEligibility,
} from "../../helpers/helpers";
import BirthdayItem from "./BirthdayItem";
import { languages } from "../../helpers/language";

const WaysToEarnSection = ({
  waysToEarnRef,
  merchantData,
  appStateData,
  customerData,
  fetchCustomer,
}) => {
  let { merchant, sortedVipTeirs } = merchantData;
  let { shopDomain, customerId } = appStateData;
  let { customer } = customerData;

  const getPointsItemDesc = (points) =>
    `${points} ${
      merchant?.pointsCurrency !== "Super-Points"
        ? merchant?.pointsCurrency
        : details.points_title
    }`;
  const getGiftcardsItemDesc = (giftcards) =>
    `${merchant?.currency.symbol}${giftcards} ${
      merchant?.currentPlan?.planName !== "free" &&
      merchant?.customWidgetTheme?.textCustomization
        ? merchant?.customWidgetTheme?.textCustomization?.giftcard
        : "Giftcard"
    }`;

  const details = {
    ways_to_earn:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.ways_to_earn"
      ],
    sign_up:
      languages[merchant?.customWidgetTheme?.language || "en"]["earn.sign_up"],
    place_an_order:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.order_title"
      ],
    celebrate_your_birthday:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.birth_day"
      ],
    share_facebook:
      languages[merchant?.customWidgetTheme?.language || "en"]["earn.fb_share"],
    follow_instagram:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.insta_follow"
      ],
    points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
    title_gift:
      languages[merchant?.theme?.language || "en"]["giftcard.title_gift"],
    title_card:
      languages[merchant?.theme?.language || "en"]["giftcard.title_card"],
    follow_tiktok:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.follow_tiktok"
      ],
    follow_linkedin:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.follow_linkedin"
      ],
    connect_line:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.connect_line"
      ],
    order_limit_note:
      languages[merchant?.theme?.language || "en"]["earn.order_limit_note"],
    order_limit_note_lifetime:
      languages[merchant?.theme?.language || "en"][
        "earn.order_limit_note_lifetime"
      ],
    share_limit_note:
      languages[merchant?.theme?.language || "en"]["earn.share_limit_note"],
    share_limit_note_lifetime:
      languages[merchant?.theme?.language || "en"][
        "earn.share_limit_note_lifetime"
      ],
  };

  const isGiftcardsActive = merchant?.isGiftcardsActive;

  const waysToEarnSettings =
    (isGiftcardsActive
      ? merchant?.waysToEarnGiftcardsSettings
      : merchant?.waysToEarnSettings) ?? {};

  let order_note = waysToEarnSettings?.orderActionResetPeriod
    ? waysToEarnSettings?.orderActionResetPeriod === "lifetime"
      ? details.order_limit_note_lifetime
          ?.replace(
            /{points_currency}/g,
            isGiftcardsActive
              ? details.title_gift + " " + details.title_card
              : merchant?.pointsCurrency !== "Super-Points"
              ? merchant?.pointsCurrency
              : details.points_title
          )
          ?.replace(
            /{value}/g,
            waysToEarnSettings?.timesOrderActionCanBePerformed
          )
      : details.order_limit_note
          ?.replace(
            /{points_currency}/g,
            isGiftcardsActive
              ? details.title_gift + " " + details.title_card
              : merchant?.pointsCurrency !== "Super-Points"
              ? merchant?.pointsCurrency
              : details.points_title
          )
          ?.replace(
            /{value1}/g,
            waysToEarnSettings?.timesOrderActionCanBePerformed
          )
          ?.replace(
            /{value2}/g,
            waysToEarnSettings?.orderActionResetPeriod?.replace(/\D/g, "")
          )
    : "";

  const getShareNote = (resetPeriod, timesActionCanBePerformed) =>
    resetPeriod && resetPeriod !== "lifetime"
      ? details.share_limit_note
          ?.replace(/{value1}/g, timesActionCanBePerformed)
          .replace(/{value2}/g, resetPeriod?.replace(/\D/g, ""))
      : "";

  const getShareEligibility = ({
    arePointsAquired,
    resetPeriod,
    timesActionCanBePerformed,
    resetCycleStartedOn,
    timesActionPerformed,
  }) => {
    // check if limit is set or use default
    if (!resetPeriod || !timesActionCanBePerformed) return !arePointsAquired;

    // check for previous actions
    if (!resetCycleStartedOn || !timesActionPerformed) return true;

    // check if limit is lifetime, compare actions performed
    if (resetPeriod === "lifetime") {
      return timesActionPerformed < timesActionCanBePerformed;
    }
    // for other periods, check if limit is reached or not
    else {
      const currentDate = new Date();
      const resetDate = new Date(resetCycleStartedOn);
      const milliSecondsInDay = 1000 * 60 * 60 * 24;

      const daysPassed = Math.trunc(
        (currentDate - resetDate) / milliSecondsInDay
      );

      if (
        daysPassed < parseInt(resetPeriod.replace(/\D/g, "")) &&
        timesActionPerformed < timesActionCanBePerformed
      )
        return true;

      if (daysPassed >= parseInt(resetPeriod.replace(/\D/g, ""))) return true;
    }
    return false;
  };

  const fbShareEligibility = getShareEligibility({
    arePointsAquired: customerId && customer?.recievedSocialPoints?.fbShare,
    resetPeriod: waysToEarnSettings?.fbShareActionResetPeriod,
    timesActionCanBePerformed:
      waysToEarnSettings?.timesFbShareActionCanBePerformed,
    resetCycleStartedOn:
      customer?.rewardsWithLimitUsage?.fbShareResetCycleStartedOn,
    timesActionPerformed:
      customer?.rewardsWithLimitUsage?.timesFbShareActionPerformed,
  });

  const fbShare_note = getShareNote(
    waysToEarnSettings?.fbShareActionResetPeriod,
    waysToEarnSettings?.timesFbShareActionCanBePerformed
  );

  const twShareEligibility = getShareEligibility({
    arePointsAquired: customerId && customer?.recievedSocialPoints?.twShare,
    resetPeriod: waysToEarnSettings?.twShareActionResetPeriod,
    timesActionCanBePerformed:
      waysToEarnSettings?.timesTwShareActionCanBePerformed,
    resetCycleStartedOn:
      customer?.rewardsWithLimitUsage?.twShareResetCycleStartedOn,
    timesActionPerformed:
      customer?.rewardsWithLimitUsage?.timesTwShareActionPerformed,
  });

  const twShare_note = getShareNote(
    waysToEarnSettings?.twShareActionResetPeriod,
    waysToEarnSettings?.timesTwShareActionCanBePerformed
  );

  const getVIPTierEligibility = (action) => {
    if (!merchant?.isVipTiersActive || !customerId) return true;

    const actionTier = waysToEarnSettings
      ? waysToEarnSettings[`${action}EligibleVIPTier`]
      : "";
    if (!actionTier) return true;

    return checkTierBenefitsEligibility(
      sortedVipTeirs ?? [],
      customer?.tierName ?? "",
      actionTier
    );
  };

  const formatLinkToHttps = (link) => {
    if (link && !link.includes("http")) {
      return `https://${link}`;
    }
    return link;
  };

  return (
    <div ref={waysToEarnRef} className="waysToEarn-section-wrapper">
      <div className="waysToEarn-heading-container">
        <h2 className="waysToEarn-heading">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.wayToEarn
            : details.ways_to_earn}
        </h2>
      </div>
      <div className="waysToEarn-items-warpper">
        {((merchant?.isPointsActive && merchant?.waysToEarn?.signup) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.signup)) && (
          <WaysToEarnItem
            imgUrl={
              merchant?.theme?.icons?.signup?.type === "custom"
                ? merchant?.theme?.icons?.signup?.location
                : signUp(merchant?.customWidgetTheme?.iconcolor)
            }
            title={
              merchant?.currentPlan?.planName !== "free" &&
              merchant?.theme?.textCustomization?.earnType
                ? merchant?.theme?.textCustomization?.earnType?.signup ??
                  details.sign_up
                : details.sign_up
            }
            desc={
              isGiftcardsActive
                ? getGiftcardsItemDesc(merchant?.signupGiftcard)
                : getPointsItemDesc(merchant?.signupPoints)
            }
            isButton={false}
          />
        )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.order) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.order)) &&
          getVIPTierEligibility("order") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.order?.type === "custom"
                  ? merchant?.theme?.icons?.order?.location
                  : orderOnline(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.order ??
                    details.place_an_order
                  : details.place_an_order
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.orderGiftcard.credit) +
                    ` per ${merchant?.currency.symbol}${merchant?.orderGiftcard.spent} Spent`
                  : getPointsItemDesc(merchant?.orderPoints) +
                    ` per ${merchant?.currency.symbol}${
                      merchant?.waysToEarnSettings?.orderSpentForPoints || 1
                    } Spent`
              }
              note={order_note}
              isButton={false}
            />
          )}

        {((merchant?.isPointsActive && merchant?.waysToEarn?.birthday) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.birthday)) &&
          getVIPTierEligibility("birthday") && (
            <BirthdayItem
              imgUrl={
                merchant?.theme?.icons?.birthday?.type === "custom"
                  ? merchant?.theme?.icons?.birthday?.location
                  : birthDay(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.birthday ??
                    details.celebrate_your_birthday
                  : details.celebrate_your_birthday
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.birthdayGiftcard)
                  : getPointsItemDesc(merchant?.birthdayPoints)
              }
              isButton={true}
              disabled={
                customerId
                  ? customer?.birthday_updated_at
                    ? (new Date() - customer?.birthday_updated_at) / 86400000 >
                      30
                    : true
                  : false
              }
              buttonText={
                merchant?.customWidgetTheme?.language === "gr"
                  ? "anpassen"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.editButton
                  : "Edit"
              }
            />
          )}

        {((merchant?.isPointsActive && merchant?.waysToEarn?.fbLike) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.fbLike)) &&
          getVIPTierEligibility("fbLike") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.fbLike?.type === "custom"
                  ? merchant?.theme?.icons?.fbLike?.location
                  : fbLike(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.fbLike ??
                    "Like on Facebook"
                  : "Like on Facebook"
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.fbLikeGiftcard)
                  : getPointsItemDesc(merchant?.fbLikePoints)
              }
              isButton={true}
              disabled={customerId && customer?.recievedSocialPoints?.fbLike}
              buttonText={
                customerId && customer?.recievedSocialPoints?.fbLike
                  ? ""
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && !customer?.recievedSocialPoints?.fbLike) {
                  window.open(formatLinkToHttps(merchant.fbPageUrl), "_blank");
                  isGiftcardsActive
                    ? await giveSocialGiftcard(shopDomain, customerId, "fbLike")
                    : await giveSocialPoints(shopDomain, customerId, "fbLike");
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.fbShare) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.fbShare)) &&
          getVIPTierEligibility("fbShare") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.fbShare?.type === "custom"
                  ? merchant?.theme?.icons?.fbShare?.location
                  : fbShare(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.fbShare ??
                    details.share_facebook
                  : details.share_facebook
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.fbShareGiftcard)
                  : getPointsItemDesc(merchant?.fbSharePoints)
              }
              note={!fbShareEligibility && fbShare_note}
              isButton={fbShareEligibility}
              disabled={!customerId || (customerId && !fbShareEligibility)}
              buttonText={
                merchant?.customWidgetTheme?.language === "gr"
                  ? "teilen"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && fbShareEligibility) {
                  console.log(!customer?.recievedSocialPoints?.fbShare);
                  window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${merchant.fbPageUrl}`,
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "fbShare"
                      )
                    : await giveSocialPoints(shopDomain, customerId, "fbShare");
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.twShare) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.twShare)) &&
          getVIPTierEligibility("twShare") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.twShare?.type === "custom"
                  ? merchant?.theme?.icons?.twShare?.location
                  : twitterShare(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.twShare ??
                    "Share on Twitter"
                  : "Share on Twitter"
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.twShareGiftcard)
                  : getPointsItemDesc(merchant?.twSharePoints)
              }
              note={!twShareEligibility && twShare_note}
              isButton={twShareEligibility}
              disabled={!customerId || (customerId && !twShareEligibility)}
              buttonText={
                merchant?.customWidgetTheme?.language === "gr"
                  ? "teilen"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && twShareEligibility) {
                  window.open(
                    `https://twitter.com/share?ref_src=twsrc%5Etfw&url=${merchant.twShareUrl}&text=${merchant.twShareMsg}`,
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "twShare"
                      )
                    : await giveSocialPoints(shopDomain, customerId, "twShare");
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.twFollow) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.twFollow)) &&
          getVIPTierEligibility("twFollow") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.twFollow?.type === "custom"
                  ? merchant?.theme?.icons?.twFollow?.location
                  : twitterFollow(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.twFollow ??
                    "Follow on Twitter"
                  : "Follow on Twitter"
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.twFollowGiftcard)
                  : getPointsItemDesc(merchant?.twFollowPoints)
              }
              isButton={true}
              disabled={customerId && customer?.recievedSocialPoints?.twFollow}
              buttonText={
                customerId && customer?.recievedSocialPoints?.twFollow
                  ? ""
                  : merchant?.customWidgetTheme?.language === "gr"
                  ? "folgen"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && !customer?.recievedSocialPoints?.twFollow) {
                  window.open(formatLinkToHttps(merchant.twShareUrl), "_blank");
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "twFollow"
                      )
                    : await giveSocialPoints(
                        shopDomain,
                        customerId,
                        "twFollow"
                      );
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.instaFollow) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.instaFollow)) &&
          getVIPTierEligibility("instaFollow") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.instaFollow?.type === "custom"
                  ? merchant?.theme?.icons?.instaFollow?.location
                  : instaFollow(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.instaFollow ??
                    details.follow_instagram
                  : details.follow_instagram
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.instaFollowGiftcard)
                  : getPointsItemDesc(merchant?.instaFollowPoints)
              }
              isButton={true}
              disabled={
                customerId && customer?.recievedSocialPoints?.instaFollow
              }
              buttonText={
                customerId && customer?.recievedSocialPoints?.instaFollow
                  ? ""
                  : merchant?.customWidgetTheme?.language === "gr"
                  ? "folgen"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (
                  customerId &&
                  !customer?.recievedSocialPoints?.instaFollow
                ) {
                  window.open(
                    `https://instagram.com/${merchant.instaUsername}`,
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "instaFollow"
                      )
                    : await giveSocialPoints(
                        shopDomain,
                        customerId,
                        "instaFollow"
                      );
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.googleReview) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.googleReview)) &&
          getVIPTierEligibility("googleReview") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.googleReview?.type === "custom"
                  ? merchant?.theme?.icons?.googleReview?.location
                  : freeProduct(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType
                      ?.googleReview ?? "Review on Google"
                  : "Review on Google"
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.googleReviewGiftcard)
                  : getPointsItemDesc(merchant?.googleReviewPoints)
              }
              isButton={true}
              disabled={!customerId}
              buttonText={
                customerId && customer?.recievedSocialPoints?.googleReview
                  ? ""
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (
                  customerId &&
                  !customer?.recievedSocialPoints?.googleReview
                ) {
                  window.open(
                    formatLinkToHttps(merchant?.googleReviewUrl),
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "googleReview"
                      )
                    : await giveSocialPoints(
                        shopDomain,
                        customerId,
                        "googleReview"
                      );
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.tiktok) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.tiktok)) &&
          getVIPTierEligibility("tiktok") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.tiktok?.type === "custom"
                  ? merchant?.theme?.icons?.tiktok?.location
                  : freeProduct(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.tiktok ??
                    details.follow_tiktok
                  : details.follow_tiktok
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.tiktokGiftcard)
                  : getPointsItemDesc(merchant?.tiktokPoints)
              }
              isButton={true}
              disabled={!customerId}
              buttonText={
                customerId && customer?.recievedSocialPoints?.tiktok
                  ? ""
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && !customer?.recievedSocialPoints?.tiktok) {
                  window.open(
                    formatLinkToHttps(merchant?.tiktokFollowUrl),
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(shopDomain, customerId, "tiktok")
                    : await giveSocialPoints(shopDomain, customerId, "tiktok");
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.linkedin) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.linkedin)) &&
          getVIPTierEligibility("linkedin") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.linkedin?.type === "custom"
                  ? merchant?.theme?.icons?.linkedin?.location
                  : freeProduct(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.linkedin ??
                    details.follow_linkedin
                  : details.follow_linkedin
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.linkedinGiftcard)
                  : getPointsItemDesc(merchant?.linkedinPoints)
              }
              isButton={true}
              disabled={!customerId}
              buttonText={
                customerId && customer?.recievedSocialPoints?.linkedin
                  ? ""
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && !customer?.recievedSocialPoints?.linkedin) {
                  window.open(
                    formatLinkToHttps(merchant?.linkedinFollowUrl),
                    "_blank"
                  );
                  isGiftcardsActive
                    ? await giveSocialGiftcard(
                        shopDomain,
                        customerId,
                        "linkedin"
                      )
                    : await giveSocialPoints(
                        shopDomain,
                        customerId,
                        "linkedin"
                      );
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}
        {((merchant?.isPointsActive && merchant?.waysToEarn?.line) ||
          (isGiftcardsActive && merchant?.waysToEarnGiftcards?.line)) &&
          getVIPTierEligibility("line") && (
            <WaysToEarnItem
              imgUrl={
                merchant?.theme?.icons?.line?.type === "custom"
                  ? merchant?.theme?.icons?.line?.location
                  : freeProduct(merchant?.customWidgetTheme?.iconcolor)
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType?.line ??
                    details.connect_line
                  : details.connect_line
              }
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(merchant?.lineGiftcard)
                  : getPointsItemDesc(merchant?.linePoints)
              }
              isButton={true}
              disabled={!customerId}
              buttonText={
                customerId && customer?.recievedSocialPoints?.line
                  ? ""
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              onClickHandler={async () => {
                if (customerId && !customer?.recievedSocialPoints?.line) {
                  window.open(formatLinkToHttps(merchant?.lineUrl), "_blank");
                  isGiftcardsActive
                    ? await giveSocialGiftcard(shopDomain, customerId, "line")
                    : await giveSocialPoints(shopDomain, customerId, "line");
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          )}

        {(merchant?.isPointsActive || isGiftcardsActive) &&
          merchant?.integrations?.judgeme?.status &&
          getVIPTierEligibility("judgeme") && (
            <WaysToEarnItem
              imgUrl={freeProduct(merchant?.customWidgetTheme?.iconcolor)}
              title="Write a review"
              desc={
                isGiftcardsActive
                  ? getGiftcardsItemDesc(
                      merchant?.integrations?.judgeme?.reviewGiftcard
                    )
                  : getPointsItemDesc(
                      merchant?.integrations?.judgeme?.reviewPoints
                    )
              }
              isButton={false}
            />
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: (customerId, shopDomain) =>
    dispatch(fetchCustomer(customerId, shopDomain)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WaysToEarnSection);
